import { pubsub } from '@services';

class LoadMore extends HTMLElement {
  paginateItems = Number(this.dataset.paginateItems);
  button = this.querySelector('button');
  collectionProductsSize = this.querySelector('[data-collection-products-size]');
  progressBar = this.querySelector('[data-progress-bar]');

  connectedCallback() {
    if (!this.button) return;
    this.button.addEventListener('click', () => this.handleClick());
    pubsub.subscribe('infinite-load:fetched', ({ productsSize }) => {
      this.handleSubscribe(productsSize);
    });
  }

  handleClick() {
    this.button.classList.add('hidden');
    pubsub.publish('load-more:clicked');
  }

  /**
   * Handle the subscribe event
   * @param {number} productsSize - The products size
   */
  handleSubscribe(productsSize) {
    this.updateCollectionProductsSize(productsSize);
    this.updateProgressBar(productsSize);
  }

  /**
   * Update the collection products size
   * @param {number} productsSize - The products size
   */
  updateCollectionProductsSize(productsSize) {
    this.collectionProductsSize.textContent = productsSize;
  }

  /**
   * Update the collection products size
   * @param {number} productsSize - The products size
   */
  updateProgressBar(productsSize) {
    const progressBarWidth = (productsSize / this.paginateItems) * 100;
    this.progressBar.style.setProperty('--progress-bar-width', `${progressBarWidth}%`);
  }
}

customElements.define('load-more', LoadMore);
